import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

import ru from '@/langs/ru.json'
import en from '@/langs/en.json'

export const i18n = new VueI18n({
    locale: 'ru',
    fallbackLocale: 'ru',
    //  Не забыть поменять meta теги в index.html !!!!!
    messages: {
        ru,
        en
    }
})
